import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { LEGAL_DOCS } from "./legalTexts";

const GmailPrivacyNotice = () => (
  <section className="mb-7 rounded-lg border border-[#d7c39d] bg-[#fffaf0] p-5 text-sm leading-6 text-slate-800" data-testid="gmail-privacy-notice">
    <h2 className="font-[Playfair_Display] text-xl font-semibold text-slate-900">Ergänzung: Google- und Gmail-Integration</h2>
    <p className="mt-3">
      Die Business Studio Suite ermöglicht berechtigten Nutzerinnen und Nutzern einer Organisation,
      ihr eigenes Gmail-Konto freiwillig mit dem CRM zu verbinden. Es wird kein Konto automatisch
      verbunden und keine E-Mail automatisch versendet.
    </p>
    <p className="mt-3">
      Nach ausdrücklicher Autorisierung verarbeitet die Suite die Gmail-Adresse, verschlüsselte
      OAuth-Zugriffsdaten sowie – nur für die gewählte CRM-Funktion – Absenderadresse, Betreff,
      Klartextinhalt und technische Nachrichten- beziehungsweise Thread-Kennungen eingehender
      E-Mails. Der Zugriff erfolgt mit den Berechtigungen <code>gmail.send</code> für einen von
      der Nutzerin oder dem Nutzer ausdrücklich ausgelösten Versand und <code>gmail.readonly</code>
      für die manuell oder nach gesonderter Aktivierung abgerufene CRM-Synchronisation.
    </p>
    <p className="mt-3">
      Zugangsdaten werden verschlüsselt und organisationsbezogen gespeichert. Eine automatische
      Synchronisation ist anfangs ausgeschaltet. Die abgerufenen Nachrichten werden ausschließlich
      innerhalb der jeweiligen Organisation in der CRM-Kommunikationschronik oder zur dortigen
      manuellen Zuordnung angezeigt. Google-Nutzerdaten werden nicht verkauft, nicht für Werbung
      oder Profilbildung genutzt und nicht an andere Organisationen weitergegeben.
    </p>
    <p className="mt-3">
      Die Gmail-Verbindung kann im CRM jederzeit getrennt werden. Dabei werden die gespeicherten
      OAuth-Zugangsdaten gelöscht. Bereits bewusst in die CRM-Kommunikationschronik übernommene
      Inhalte bleiben bis zu ihrer Löschung nach den allgemeinen Regeln der Kundenakte gespeichert.
    </p>
    <p className="mt-3">
      Die Nutzung und Weitergabe von Informationen, die von Google APIs empfangen werden, erfolgt
      in Übereinstimmung mit der <a className="underline" href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noreferrer">Google API Services User Data Policy</a>, einschließlich der Anforderungen zur eingeschränkten Nutzung („Limited Use“).
    </p>
    <Link
      to="/google-api-datenschutz"
      className="mt-4 inline-block font-medium text-slate-900 underline"
      data-testid="gmail-privacy-details-link"
    >
      Vollständige Google-API-Datenschutzhinweise lesen
    </Link>
  </section>
);

export const LegalPage = ({ docKey }) => {
  const navigate = useNavigate();
  const doc = LEGAL_DOCS[docKey];
  if (!doc) return null;
  const isPrivacy = docKey === "datenschutz";
  return (
    <main className="min-h-screen bg-[#f7f4ee] px-4 py-8 text-slate-900" data-testid={`legal-page-${docKey}`}>
      <div className="mx-auto max-w-4xl">
        <header className="mb-6 flex items-center justify-between gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#9c742e]">Business Studio Suite</p>
            <h1 className="mt-1 font-[Playfair_Display] text-3xl font-semibold">{doc.label}</h1>
          </div>
          <button
            onClick={() => navigate("/")}
            className="rounded-full border border-slate-300 bg-white px-4 py-2 text-sm text-slate-700"
            data-testid="legal-page-back"
          >
            Zur Startseite
          </button>
        </header>
        {isPrivacy && <GmailPrivacyNotice />}
        <section className="border border-slate-200 bg-white p-2" aria-label={doc.label}>
          <iframe
            title={doc.label}
            src={doc.url}
            className="min-h-[1200px] w-full bg-white"
            data-testid={`legal-page-iframe-${docKey}`}
          />
        </section>
      </div>
    </main>
  );
};

export default LegalPage;
